module.exports = __webpack_public_path__ + "static/event-image-3-4a01784a1b830fe842c000db54aac68d.jpg";